// ═══════════════════════════════════════════════════════════
// ARAMS Dashboard — Global Store (Valtio)
// ═══════════════════════════════════════════════════════════

import { proxy, subscribe } from 'valtio';
import type { User, Project } from './api';

interface AppState {
  user: User | null;
  token: string | null;
  currentProject: Project | null;
  sidebarCollapsed: boolean;
  theme: 'dark' | 'light';
  wsConnected: boolean;
}

export const store = proxy<AppState>({
  user: null,
  token: localStorage.getItem('arams_token'),
  currentProject: null,
  sidebarCollapsed: false,
  theme: 'dark',
  wsConnected: false,
});

// Persist token changes
subscribe(store, () => {
  if (store.token) {
    localStorage.setItem('arams_token', store.token);
  } else {
    localStorage.removeItem('arams_token');
  }
});

export function setAuth(user: User, token: string) {
  store.user = user;
  store.token = token;
}

export function logout() {
  store.user = null;
  store.token = null;
  store.currentProject = null;
}
